import React from 'react';
import './Stack.css';

const SPACING_TO_VAR = {
  0: 'var(--space-0)',
  1: 'var(--space-1)',
  2: 'var(--space-2)',
  3: 'var(--space-3)',
  4: 'var(--space-4)',
  5: 'var(--space-5)',
  6: 'var(--space-6)',
  8: 'var(--space-8)',
  10: 'var(--space-10)',
  12: 'var(--space-12)',
};

function Stack({
  children,
  gap = 4,
  align = 'stretch',
  justify = 'start',
  as: Tag = 'div',
  className = '',
  style = {},
  ...rest
}) {
  const mergedStyle = {
    gap: SPACING_TO_VAR[gap] || `${gap}px`,
    alignItems: align,
    justifyContent: justify,
    ...style,
  };
  return (
    <Tag className={`ui-stack ${className}`} style={mergedStyle} {...rest}>
      {children}
    </Tag>
  );
}

export default Stack;
